import React, { Component } from 'react'
import './index.scss';
import Link from '../Link';

export default class SGButton extends Component {
  render() {
    return (
        <Link to={this.props.to}>
            <div className={"sg-button"}>
                <span className="sg-button--text">{ this.props.title } </span>
                <span className="sg-button--arrow">
                    <svg style={{ width:'14px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 12.7" className="_2H5xozcs7D"><path class="arrow" d="M24 6.3L18 0l-1.3 1.5 3.6 3.9H0v2h20.3l-3.6 3.8 1.3 1.5 6-6.3z"></path></svg>
                </span>
            </div>
        </Link>
           
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SGButton/index.js